import type { Middleware, Reducer } from '@reduxjs/toolkit'

import { rootApi } from 'common/store/api/rootApi'

import { adminApi } from 'features/Admin'
import { authApi } from 'features/Auth'
import { bookingApi } from 'features/Booking'
import { cartApi } from 'features/Cart'
import { faqApi } from 'features/Faq'
import { bookApi } from 'features/Home/Book/state/api/bookApi'
import { promotionsApi } from 'features/Home/Promotion/state/promotionsApi'
import { optionApi } from 'features/Option'
import { patientsApi } from 'features/Patients'
import { transactionsMappingApi } from 'features/Profile/features/TransactionsMapping/transactionsMapping.api'
import { providerApi } from 'features/Provider'
import { chiefComplaintsApi } from 'features/Schedule/api/chiefComplaints.api'
import { medicalIssuesApi } from 'features/Schedule/api/medicalIssues.api'
import { scheduleApi } from 'features/Schedule/api/schedule.api'
import { settingsApi } from 'features/SettingsOld/state/api/settingsApi'
import { staffApi } from 'features/Staff'
import { supportApi } from 'features/Support'
import { patientDataApi } from 'features/Profile/features/Prescriptions/patient-data.api'
import { procedureApi } from 'features/Procedure/state/procedure.api'
type ApiReducerObject = Record<string, Reducer>

export const APP_API_LIST = [
  faqApi,
  authApi,
  rootApi,
  cartApi,
  bookApi,
  bookingApi,
  staffApi,
  promotionsApi,
  optionApi,
  supportApi,
  settingsApi,
  providerApi,
  patientsApi,
  adminApi,
  scheduleApi,
  transactionsMappingApi,
  patientDataApi,
  procedureApi,
  medicalIssuesApi,
  chiefComplaintsApi,
]

const getAppMiddlewareList = (): Middleware[] => APP_API_LIST.map((api) => api.middleware)
const getAppApiReducerList = (): ApiReducerObject =>
  APP_API_LIST.reduce<ApiReducerObject>((acc: ApiReducerObject, api) => {
    acc[api.reducerPath] = api.reducer
    return acc
  }, {})

export const StateService = {
  getAppMiddlewareList,
  getAppApiReducerList,
}
